import { plural } from '../index';
import { defineMessages } from '../define';

/** Общие подписи из lib/, api/ и telegram/: даты, ошибки, подтверждения. */
export const lib = defineMessages({
  ru: {
    'lib.today': 'Сегодня',
    'lib.yesterday': 'Вчера',
    'lib.due.today': 'сегодня',
    'lib.due.tomorrow': 'завтра',
    'lib.due.inDays': (p: { n: number }) => `через ${p.n} ${plural(p.n, { one: 'день', few: 'дня', other: 'дней' })}`,
    'lib.due.late': (p: { n: number }) => `просрочен на ${p.n} ${plural(p.n, { one: 'день', few: 'дня', other: 'дней' })}`,
    'lib.error.network': 'Нет связи с сервером. Проверьте интернет и попробуйте снова.',
    'lib.error.timeout': 'Сервер долго не отвечает. Попробуйте ещё раз.',
    'lib.error.forbidden': 'Нет доступа: приложение открыто не из Telegram или для этого аккаунта доступ закрыт.',
    'lib.error.server': 'Сервер не отвечает. Попробуйте ещё раз через минуту.',
    'lib.error.unknown': 'Что-то пошло не так',
    'lib.error.status': (p: { n: number }) => `Запрос завершился с кодом ${p.n}`,
    'lib.noCategory': 'Без категории',
    'lib.category': 'Категория',
    'lib.confirm.title': 'Подтверждение',
    'lib.confirm.delete': 'Удалить',
  },
  en: {
    'lib.today': 'Today',
    'lib.yesterday': 'Yesterday',
    'lib.due.today': 'today',
    'lib.due.tomorrow': 'tomorrow',
    'lib.due.inDays': (p: { n: number }) => `in ${p.n} ${plural(p.n, { one: 'day', other: 'days' })}`,
    'lib.due.late': (p: { n: number }) => `${p.n} ${plural(p.n, { one: 'day', other: 'days' })} overdue`,
    'lib.error.network': 'No connection to the server. Check your internet and try again.',
    'lib.error.timeout': 'The server is taking too long. Please try again.',
    'lib.error.forbidden': 'No access: the app was opened outside Telegram or access is closed for this account.',
    'lib.error.server': 'The server is not responding. Try again in a minute.',
    'lib.error.unknown': 'Something went wrong',
    'lib.error.status': (p: { n: number }) => `Request failed with status ${p.n}`,
    'lib.noCategory': 'No category',
    'lib.category': 'Category',
    'lib.confirm.title': 'Confirmation',
    'lib.confirm.delete': 'Delete',
  },
  be: {
    'lib.today': 'Сёння',
    'lib.yesterday': 'Учора',
    'lib.due.today': 'сёння',
    'lib.due.tomorrow': 'заўтра',
    'lib.due.inDays': (p: { n: number }) => `праз ${p.n} ${plural(p.n, { one: 'дзень', few: 'дні', other: 'дзён' })}`,
    'lib.due.late': (p: { n: number }) => `пратэрмінаваны на ${p.n} ${plural(p.n, { one: 'дзень', few: 'дні', other: 'дзён' })}`,
    'lib.error.network': 'Няма сувязі з серверам. Праверце інтэрнэт і паспрабуйце зноў.',
    'lib.error.timeout': 'Сервер доўга не адказвае. Паспрабуйце яшчэ раз.',
    'lib.error.forbidden': 'Няма доступу: праграма адкрыта не з Telegram або для гэтага акаўнта доступ закрыты.',
    'lib.error.server': 'Сервер не адказвае. Паспрабуйце яшчэ раз праз хвіліну.',
    'lib.error.unknown': 'Нешта пайшло не так',
    'lib.error.status': (p: { n: number }) => `Запыт завяршыўся з кодам ${p.n}`,
    'lib.noCategory': 'Без катэгорыі',
    'lib.category': 'Катэгорыя',
    'lib.confirm.title': 'Пацвярджэнне',
    'lib.confirm.delete': 'Выдаліць',
  },
});
